<template>
  <section class="global-background-footer">

    <div class="container steps-area">
      <div class="is-centered">
        <div style="width: 100%">

          <ul class="steps is-narrow is-centered has-content-centered" style="width: 100%;">
            <!-- <div class="" v-for="activity in activities"> -->
                <li v-if="showActivity(index)" v-bind:class="{'steps-segment':true, 'is-active':checkIndex(index+1), 'has-gaps':checkGaps(index)}" v-for="(activity, index) in activities">
              <span style="cursor: pointer" v-bind:class="{'steps-marker':true, 'is-hollow hollow':checkIndex(index)}" :index="index" @click="changeActivity(index)">
                  <!-- <span class="icon">
                    <i class="fa fa-check"></i>
                  </span> -->
                </span>
                <div class="steps-content">
                  <p class="is-size-6 has-text-weight-bold step-title">{{ activity.name }}</p>
                </div>
              </li>
            <!-- </div> -->

          </ul>

          <!-- back -->
          <!-- <div v-if="(activities[active + 1])" class="columns is-centered">
            <div class="column is-full">
              <a @click="changeActivity(active + 1)" class="button has-text-weight-bold is-rounded send-button" :style="{backgroundColor: $store.getters.clientStyle.secondary, borderColor: $store.getters.clientStyle.secondary}">Volgende</a>
            </div>
          </div> -->

        </div>
      </div>
      
      
    </div>

    <div class="container arrow-buttons">
      <div class="columns is-centered">
        <div class="column is-one-sixth">
          <!-- next -->
          <!-- <div v-if="checkNext(true)" class="columns" style="float: left; padding-left: 5px;">
            <img src="../../../assets/back.svg" alt="back" class="next-button" @click="changeActivity(active - 1)">
             -->
            <!-- <div class="column is-full">
              <a @click="changeActivity(active - 1)" class="button has-text-weight-bold is-rounded send-button" :style="{backgroundColor: $store.getters.clientStyle.secondary, borderColor: $store.getters.clientStyle.secondary}">Terug</a>
            </div> -->
          <!-- </div> -->
          <div v-if="checkNext(false)" class="columns" style="float: left">
            <img src="../../../assets/back.svg" alt="back" class="next-button" @click="changeActivity(active - 1)">

            <!-- <div class="column is-full">
              <a @click="changeActivity(active - 1)" class="button has-text-weight-bold is-rounded send-button" :style="{backgroundColor: $store.getters.clientStyle.secondary, borderColor: $store.getters.clientStyle.secondary}">Terug</a>
            </div> -->
          </div>
          <p v-if="checkNext(false)" class="is-size-4 has-text-weigt-bold" style="float: left; padding-left: 5px; cursor: pointer;" @click="changeActivity(active - 1)">Vorige</p>

        </div>

        

        <div class="column is-one-sixth">
          <!-- back -->
          <!-- <div v-if="checkBack(false)" class="columns" style="float: right; padding-right: 5px;">
            <img src="../../../assets/next.svg" alt="next" class="next-button" @click="changeActivity(active + 1)">
             -->
            <!-- <div class="column is-full">
              <a @click="changeActivity(active - 1)" class="button has-text-weight-bold is-rounded send-button" :style="{backgroundColor: $store.getters.clientStyle.secondary, borderColor: $store.getters.clientStyle.secondary}">Terug</a>
            </div> -->
          <!-- </div> -->
          <div v-if="checkBack(true)" class="columns" style="float: right">
            <img src="../../../assets/next.svg" alt="next" class="next-button" @click="changeActivity(active + 1)">

            <!-- <div class="column is-full">
              <a @click="changeActivity(active - 1)" class="button has-text-weight-bold is-rounded send-button" :style="{backgroundColor: $store.getters.clientStyle.secondary, borderColor: $store.getters.clientStyle.secondary}">Terug</a>
            </div> -->
          </div>
          <p v-if="checkBack(true)" class="is-size-4 has-text-weigt-bold" style="float: right; padding-right: 5px; cursor: pointer;" @click="changeActivity(active + 1)">Volgende</p>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  data() {
    return {
        activities: this.$store.getters.getActivities,
        active: this.$store.getters.getActiveActivity
    }
  },
  created () {
    window.addEventListener('keydown', (e) => {
      e.stopPropagation()
      if (e.key == 'ArrowRight') {
        e.preventDefault()
        this.changeActivity(Number(this.active) + 1)
      } else if (e.key == 'ArrowLeft') {
        e.preventDefault()
        this.changeActivity(Number(this.active) - 1)
      }
    });
  },
  methods: {
    toast() {
        this.$toast.open({
            duration: 4000,
            message: 'Niet alle verplichte vragen zijn ingevuld.',
        })
    },
    checkNext(index) {
      if (index) {
        if (this.active - 3 < 0) {
          return false
        } else {
          return true
        }
      } else {
        if (this.active - 1 < 0) {
          return false
        } else {
          return true
        }
      }
    },
    checkBack(index) {
      if (index) {
        if (this.active + 2 > this.activities.length) {
          return false
        } else {
          return true
        }
      } else {
        if (this.active + 4 > this.activities.length) {
          return false
        } else {
          return true
        }
      }
    },
    CheckCompleted(activity) {
      var completed = this.$store.getters.getCompletedActivities;
      var isCompleted = false;
      for (var i = 0; i < completed.length; i++) {
        if (activity == completed[i]) {
          isCompleted = true
        }
      }
      return isCompleted;
    },
    LoadActivity() {

    },
    changeActivity (index) {
      if (index == this.active) {
        return
      } else if ( index < 0 || index > this.activities.length - 1) {
        return
      }
      //fade out
      this.$emit('clicked', index)
      this.active = index
    },
    checkIndex: function(index) {
      if (index == this.active) {
        return true
      } else {
        return false
      }
    },
    checkGaps(index) {
      if (index >= this.active) {
        return true
      } else {
        return false
      }
    },
    showActivity(index) {
      if(index > this.active - 3 && index < this.active + 3) {
        return true
      } else if(this.active == 0 && index <= 4) {
        return true
      } else if (this.active == (this.activities.length -1) && index >= (this.activities.length - 5)) {
        return true
      } else if(this.active == 1 && index <= 4) {
        return true
      } else if (this.active == (this.activities.length -2) && index >= (this.activities.length - 5)) {
        return true
      } else {
        return false
      }
    }
},
mounted() {
  //fade in
},
props: ['index']
}

</script>

<style scoped>

.hollow {
  background-color: #f8f8f8
}

.steps-area {
  margin-top: -100px;
  padding-top: 150px;
  padding-bottom: 10px;
  text-align: center;
}

.steps:not(.is-hollow) .steps-marker:not(.is-hollow) {
    background-color: #5a5a5a;
    /* #00294c */
    color: #fff;
}

.steps:not(.is-hollow) .steps-segment.is-active .steps-marker:not(.is-hollow) {
    background-color: #5a5a5a;
    color: #fff;
}

/* .steps.is-hollow .is-active .steps-marker, .steps .is-active .steps-marker.is-hollow {
    border-color: #5a5a5a;
} */

.steps.is-hollow .steps-segment .steps-marker, .steps-marker.is-hollow {
    border-color: #5a5a5a;
}

.steps.is-hollow .steps-segment.is-active ~ .steps-segment .steps-marker, .steps-segment.is-active ~ .steps-segment .steps-marker.is-hollow {
    border-color: #5a5a5a;
}

.steps-segment:after {
  background-color: #5a5a5a;
}

.step-title {
  padding-top: 4px;
}

.next-button {
  cursor: pointer;
  height: 60px;
}

.arrow-buttons {
  text-align: center;
  max-width: 960px;
  padding-top: 50px;
  margin-bottom: -130px;
  z-index: 9;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/footer/FormSteps.vue